<h1 *ngIf="!ingestConfig.hasColumns()" class="center" style="color: lightgray">(Select 'Run Auto Mapper or Find Previous Mapping')</h1>

<table *ngIf="ingestConfig.hasColumns()" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; "> Index </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; "> {{def.index}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px; "> Name </th>
        <td mat-cell *matCellDef="let def" style="width: 150px;"> 
           <span [ngStyle]="{'color': def.showPlaceholderDelbtn ? 'gray' : ''}">
            {{ def.showPlaceholderDelbtn ? '&lt;Placeholder&gt;' : def.columnName }}
           </span> 
        </td>
    </ng-container>

    <ng-container matColumnDef="targetColumnName">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px; "> Target Column </th>
        <td mat-cell *matCellDef="let def; let i = index" style="margin-left: 3px; margin-right: 3px; width: 190px; padding-right: 10px;">
            <app-autocomplete-field 
                [options]="options" 
                [disabledColumns]="disabledColumns"
                [placeholder]="defaultTargetColumn" 
                [(ngModel)]="def.targetColumnName"
                (ngModelChange)="onTargetColumnCleared(def, $event)"
                (selectionChange)="onTargetColumnChanged(def, $event)"
                (moveToNextField)="handleMoveToField($event, i)"
                ></app-autocomplete-field>
            <!-- <mat-select [disabled]="ingestConfig.masterColumnMapGuid.length > 0" [placeholder]="defaultTargetColumn" [(ngModel)]="def.targetColumnName" (selectionChange)="onTargetColumnChanged(def, $event)">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let item of targetColumns" [value]="item.text" [disabled]="isOptionDisabled(item.text)" >{{item.text}}</mat-option>
            </mat-select> -->
        </td>
    </ng-container>

    <ng-container matColumnDef="dataType">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px; "> Data Type </th>
        <td mat-cell *matCellDef="let def" style="margin-left: 3px; margin-right: 3px; "> {{def.dataType}} </td>
    </ng-container>

    <ng-container matColumnDef="pyDataType">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px; "> Python Data Type </th>
        <td mat-cell *matCellDef="let def" style="margin-left: 3px; margin-right: 3px; "> {{def.pyDataType}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px;"> Description </th>
        <td mat-cell *matCellDef="let def">
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <div style="color: gray;">{{ def.description }}</div>
                <button mat-icon-button (click)="deleteThePlaceholderRow(def)" aria-label="Delete" *ngIf="def.showPlaceholderDelbtn">
                    <mat-icon class="red-icon">delete_forever</mat-icon>
                </button>
            </div>
        </td>
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>